import { FunctionComponent, useRef, useState } from 'react';
import styles from "./VerifyOTP.module.css";
import cn from 'classnames';
import { Form } from 'react-bootstrap';
import { PageRoutes } from '../../../routing/paths';
import { Link } from 'react-router-dom';
import AuthLayout from '../../../component/common/Layout/AuthLayout/AuthLayout';
import { useNavigate } from "react-router-dom";

interface IResetPasswordVerifyOTPProps {
  length?: number;
  onChangeOtp?: (otp: string) => void;
}

const ResetPasswordVerifyOTP: FunctionComponent<IResetPasswordVerifyOTPProps> = ({ length = 6, onChangeOtp }) => {
  const navigate = useNavigate();


  const inputsRef = useRef<HTMLInputElement[]>([]);
  const [otp, setOtp] = useState<string[]>(Array(length).fill(''));
  const [isFilledByUser, setIsFilledByUser] = useState(false);

  const checkIfAllFilled = (otpArray: string[]) => {
    return otpArray.every((digit) => digit.trim() !== '');
    };

  const handleChange = (value: string, index: number) => {
    if (!/^\d*$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    onChangeOtp?.(updatedOtp.join(''));
    setIsFilledByUser(checkIfAllFilled(updatedOtp));
    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('text').slice(0, length);
    if (!/^\d+$/.test(pasted)) return;
    const updated = pasted.split('');
    for (let i = 0; i < length; i++) {
      otp[i] = updated[i] || '';

    }
    setOtp([...otp]);
    onChangeOtp?.(otp.join(''));
    setIsFilledByUser(checkIfAllFilled(otp));
    inputsRef.current[pasted.length - 1]?.focus();
  };

    return (
        <AuthLayout>
            <div className={styles.header}>OTP verification</div>
            <div className={styles.otpText}>We’ve sent a 6 digit code to TestFishinity@gmail.com. <br /> Not your email? <Link to={PageRoutes.FORGOTPASSWORD} className={styles.link}>Change it</Link></div>
            <div className={styles.resendCodeHeader}>
                <div className={styles.resendCodeLabel}>Enter Code</div>
                <div className={styles.resendCodeTimer}>Expires in {'00:30'}</div>
            </div>
            <div className={styles.verifyformOut}>
                <div className={styles.verifyform}>
                    {otp.map((digit, i) => (
                      <Form.Control
                        ref={(el: HTMLInputElement | null) => {
                          if (el) {
                            inputsRef.current[i] = el;
                          }
                        }}
                        key={i}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, i)}
                        onKeyDown={(e) => handleKeyDown(e as React.KeyboardEvent<HTMLInputElement>, i)}
                        onPaste={handlePaste}
                        className={styles.otpInput}
                        autoFocus={i === 0}
                      />
                    ))}
                </div>
                <div className={cn(styles.errorText)}>OTP is invalid</div>
            </div>
            <div className={cn(styles.submit, styles.mb4)}>
                <button 
                    className='customBtn greenBtn'
                    onClick={() => {navigate(PageRoutes.RESETPASSWORD);}}
                    disabled={!isFilledByUser}
                >Reset Password</button>
            </div>
            <div className={styles.resendCode}>
                Didn't get the code? <button 
                    className='linkButton'
                    onClick={() => {}}
                >Resend</button>
            </div>
        </AuthLayout>
    );
};

export default ResetPasswordVerifyOTP;
